/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { DailyTransactionLogModel } from '../model/dailyTransactionLogModel';
import { MonthlyTransactionLogModel } from '../model/monthlyTransactionLogModel';
import { TransactionLog } from '../model/transactionLog';
import { TransactionLogDto } from '../model/transactionLogDto';
import { TransactionLogModelDto } from '../model/transactionLogModelDto';
import { WeeklyTransactionLogModel } from '../model/weeklyTransactionLogModel';
import { YearlyTransactionLogModel } from '../model/yearlyTransactionLogModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class TransactionLogService {

    protected basePath = 'http://10.1.1.123:30116';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     *
     *
     * @param transactionLog
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transactionLogAddTransactionLog(transactionLog: TransactionLog, observe?: 'body', reportProgress?: boolean): Observable<TransactionLog>;
    public transactionLogAddTransactionLog(transactionLog: TransactionLog, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TransactionLog>>;
    public transactionLogAddTransactionLog(transactionLog: TransactionLog, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TransactionLog>>;
    public transactionLogAddTransactionLog(transactionLog: TransactionLog, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (transactionLog === null || transactionLog === undefined) {
            throw new Error('Required parameter transactionLog was null or undefined when calling transactionLogAddTransactionLog.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<TransactionLog>(`${this.basePath}/api/TransactionLog/add`,
            transactionLog,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param serviceProviderId
     * @param from
     * @param to
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transactionLogDailyTransactionLog(serviceProviderId?: string, from?: Date, to?: Date, observe?: 'body', reportProgress?: boolean): Observable<Array<DailyTransactionLogModel>>;
    public transactionLogDailyTransactionLog(serviceProviderId?: string, from?: Date, to?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DailyTransactionLogModel>>>;
    public transactionLogDailyTransactionLog(serviceProviderId?: string, from?: Date, to?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DailyTransactionLogModel>>>;
    public transactionLogDailyTransactionLog(serviceProviderId?: string, from?: Date, to?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from.toISOString());
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to.toISOString());
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<DailyTransactionLogModel>>(`${this.basePath}/api/TransactionLog/dailyreport`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param transactionlogId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transactionLogDeleteTransactionLog(transactionlogId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public transactionLogDeleteTransactionLog(transactionlogId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public transactionLogDeleteTransactionLog(transactionlogId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public transactionLogDeleteTransactionLog(transactionlogId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (transactionlogId === null || transactionlogId === undefined) {
            throw new Error('Required parameter transactionlogId was null or undefined when calling transactionLogDeleteTransactionLog.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<any>(`${this.basePath}/api/TransactionLog/Delete/${encodeURIComponent(String(transactionlogId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param serviceProviderId
     * @param serviceCode
     * @param msisdn
     * @param partnerName
     * @param serviceType
     * @param dateStart
     * @param dateEnd
     * @param direction
     * @param status
     * @param keyword
     * @param route
     * @param operatorName
     * @param startIndex
     * @param count
     * @param referenceNumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transactionLogGetAllTransactionLog(serviceProviderId?: string, serviceCode?: string, msisdn?: string, partnerName?: string, serviceType?: string, dateStart?: Date, dateEnd?: Date, direction?: string, status?: number, keyword?: string, route?: string, operatorName?: string, startIndex?: number, count?: number, referenceNumber?: string, observe?: 'body', reportProgress?: boolean): Observable<TransactionLogModelDto>;
    public transactionLogGetAllTransactionLog(serviceProviderId?: string, serviceCode?: string, msisdn?: string, partnerName?: string, serviceType?: string, dateStart?: Date, dateEnd?: Date, direction?: string, status?: number, keyword?: string, route?: string, operatorName?: string, startIndex?: number, count?: number, referenceNumber?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TransactionLogModelDto>>;
    public transactionLogGetAllTransactionLog(serviceProviderId?: string, serviceCode?: string, msisdn?: string, partnerName?: string, serviceType?: string, dateStart?: Date, dateEnd?: Date, direction?: string, status?: number, keyword?: string, route?: string, operatorName?: string, startIndex?: number, count?: number, referenceNumber?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TransactionLogModelDto>>;
    public transactionLogGetAllTransactionLog(serviceProviderId?: string, serviceCode?: string, msisdn?: string, partnerName?: string, serviceType?: string, dateStart?: Date, dateEnd?: Date, direction?: string, status?: number, keyword?: string, route?: string, operatorName?: string, startIndex?: number, count?: number, referenceNumber?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
















        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (serviceCode !== undefined && serviceCode !== null) {
            queryParameters = queryParameters.set('serviceCode', <any>serviceCode);
        }
        if (msisdn !== undefined && msisdn !== null) {
            queryParameters = queryParameters.set('msisdn', <any>msisdn);
        }
        if (partnerName !== undefined && partnerName !== null) {
            queryParameters = queryParameters.set('partnerName', <any>partnerName);
        }
        if (serviceType !== undefined && serviceType !== null) {
            queryParameters = queryParameters.set('serviceType', <any>serviceType);
        }
        if (dateStart !== undefined && dateStart !== null) {
            queryParameters = queryParameters.set('dateStart', <any> new Date(dateStart).toISOString());
        }
        if (dateEnd !== undefined && dateEnd !== null) {
            queryParameters = queryParameters.set('dateEnd',  <any> new Date  (dateEnd).toISOString());
        }
        if (direction !== undefined && direction !== null) {
            queryParameters = queryParameters.set('direction', <any>direction);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }
        if (keyword !== undefined && keyword !== null) {
            queryParameters = queryParameters.set('keyword', <any>keyword);
        }
        if (route !== undefined && route !== null) {
            queryParameters = queryParameters.set('route', <any>route);
        }
        if (operatorName !== undefined && operatorName !== null) {
            queryParameters = queryParameters.set('operatorName', <any>operatorName);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }
        if (referenceNumber !== undefined && referenceNumber !== null) {
            queryParameters = queryParameters.set('referenceNumber', <any>referenceNumber);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<TransactionLogModelDto>(`${this.basePath}/api/TransactionLog/GetAllTransactionLog`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param aggregatorServiceProviderIds
     * @param serviceProviderId
     * @param dateStart
     * @param dateEnd
     * @param route
     * @param startIndex
     * @param count
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transactionLogGetAllTransactionLogForAggregator(aggregatorServiceProviderIds?: string, serviceProviderId?: string, dateStart?: Date, dateEnd?: Date, route?: string, startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<TransactionLogModelDto>;
    public transactionLogGetAllTransactionLogForAggregator(aggregatorServiceProviderIds?: string, serviceProviderId?: string, dateStart?: Date, dateEnd?: Date, route?: string, startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TransactionLogModelDto>>;
    public transactionLogGetAllTransactionLogForAggregator(aggregatorServiceProviderIds?: string, serviceProviderId?: string, dateStart?: Date, dateEnd?: Date, route?: string, startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TransactionLogModelDto>>;
    public transactionLogGetAllTransactionLogForAggregator(aggregatorServiceProviderIds?: string, serviceProviderId?: string, dateStart?: Date, dateEnd?: Date, route?: string, startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (aggregatorServiceProviderIds !== undefined && aggregatorServiceProviderIds !== null) {
            queryParameters = queryParameters.set('aggregatorServiceProviderIds', <any>aggregatorServiceProviderIds);
        }
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }

      //  if (dateStart !== undefined && dateStart !== null) {
       //     queryParameters = queryParameters.set('dateStart', <any>dateStart.toISOString());
       // }
        //if (dateEnd !== undefined && dateEnd !== null) {
          //  queryParameters = queryParameters.set('dateEnd', <any>dateEnd.toISOString());
        //}
       if (dateStart !== undefined && dateStart !== null) {
            queryParameters = queryParameters.set('dateStart', <any> new Date(dateStart).toISOString());
        }
        if (dateEnd !== undefined && dateEnd !== null) {
            queryParameters = queryParameters.set('dateEnd', <any> new Date  (dateEnd).toISOString());
        }

        if (route !== undefined && route !== null) {
            queryParameters = queryParameters.set('route', <any>route);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<TransactionLogModelDto>(`${this.basePath}/api/TransactionLog/GetAllTransactionLogForAggregator`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param serviceProviderId
     * @param searchword
     * @param startIndex
     * @param count
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transactionLogGetAllsentMessages(serviceProviderId?: string, searchword?: string, startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<TransactionLogModelDto>;
    public transactionLogGetAllsentMessages(serviceProviderId?: string, searchword?: string, startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TransactionLogModelDto>>;
    public transactionLogGetAllsentMessages(serviceProviderId?: string, searchword?: string, startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TransactionLogModelDto>>;
    public transactionLogGetAllsentMessages(serviceProviderId?: string, searchword?: string, startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (searchword !== undefined && searchword !== null) {
            queryParameters = queryParameters.set('searchword', <any>searchword);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<TransactionLogModelDto>(`${this.basePath}/api/TransactionLog/GetAllsentMessages`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param creatorId
     * @param startIndex
     * @param count
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transactionLogGetTransactionLogByCreatorId(creatorId?: string, startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<TransactionLog>>;
    public transactionLogGetTransactionLogByCreatorId(creatorId?: string, startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TransactionLog>>>;
    public transactionLogGetTransactionLogByCreatorId(creatorId?: string, startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TransactionLog>>>;
    public transactionLogGetTransactionLogByCreatorId(creatorId?: string, startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('CreatorId', <any>creatorId);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<TransactionLog>>(`${this.basePath}/api/TransactionLog/GetTransactionLogByCreatorId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param serviceProviderId
     * @param dateStart
     * @param dateEnd
     * @param startIndex
     * @param count
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transactionLogGetTransactionLogByDateCreated(serviceProviderId?: string, dateStart?: Date, dateEnd?: Date, startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<TransactionLog>>;
    public transactionLogGetTransactionLogByDateCreated(serviceProviderId?: string, dateStart?: Date, dateEnd?: Date, startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TransactionLog>>>;
    public transactionLogGetTransactionLogByDateCreated(serviceProviderId?: string, dateStart?: Date, dateEnd?: Date, startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TransactionLog>>>;
    public transactionLogGetTransactionLogByDateCreated(serviceProviderId?: string, dateStart?: Date, dateEnd?: Date, startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (dateStart !== undefined && dateStart !== null) {
            queryParameters = queryParameters.set('dateStart', <any>dateStart.toISOString());
        }
        if (dateEnd !== undefined && dateEnd !== null) {
            queryParameters = queryParameters.set('dateEnd', <any>dateEnd.toISOString());
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<TransactionLog>>(`${this.basePath}/api/TransactionLog/GetTransactionLogByDateCreated`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param transactionlogId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transactionLogGetTransactionLogById(transactionlogId: string, observe?: 'body', reportProgress?: boolean): Observable<TransactionLog>;
    public transactionLogGetTransactionLogById(transactionlogId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TransactionLog>>;
    public transactionLogGetTransactionLogById(transactionlogId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TransactionLog>>;
    public transactionLogGetTransactionLogById(transactionlogId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (transactionlogId === null || transactionlogId === undefined) {
            throw new Error('Required parameter transactionlogId was null or undefined when calling transactionLogGetTransactionLogById.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<TransactionLog>(`${this.basePath}/api/TransactionLog/GetTransactionLogById/${encodeURIComponent(String(transactionlogId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param propertyName
     * @param value
     * @param value2
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transactionLogGetTransactionLogByProperty(propertyName: string, value: any, value2: string, observe?: 'body', reportProgress?: boolean): Observable<Array<TransactionLog>>;
    public transactionLogGetTransactionLogByProperty(propertyName: string, value: any, value2: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TransactionLog>>>;
    public transactionLogGetTransactionLogByProperty(propertyName: string, value: any, value2: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TransactionLog>>>;
    public transactionLogGetTransactionLogByProperty(propertyName: string, value: any, value2: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (propertyName === null || propertyName === undefined) {
            throw new Error('Required parameter propertyName was null or undefined when calling transactionLogGetTransactionLogByProperty.');
        }

        if (value === null || value === undefined) {
            throw new Error('Required parameter value was null or undefined when calling transactionLogGetTransactionLogByProperty.');
        }

        if (value2 === null || value2 === undefined) {
            throw new Error('Required parameter value2 was null or undefined when calling transactionLogGetTransactionLogByProperty.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.get<Array<TransactionLog>>(`${this.basePath}/api/TransactionLog/GetTransactionLogByProperty/${encodeURIComponent(String(propertyName))}/${encodeURIComponent(String(value))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param referenceNumber
     * @param searchWord
     * @param skip
     * @param take
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transactionLogGetTransactionLogByReferenceNumber(referenceNumber: string, searchWord?: string, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<TransactionLogDto>;
    public transactionLogGetTransactionLogByReferenceNumber(referenceNumber: string, searchWord?: string, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TransactionLogDto>>;
    public transactionLogGetTransactionLogByReferenceNumber(referenceNumber: string, searchWord?: string, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TransactionLogDto>>;
    public transactionLogGetTransactionLogByReferenceNumber(referenceNumber: string, searchWord?: string, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (referenceNumber === null || referenceNumber === undefined) {
            throw new Error('Required parameter referenceNumber was null or undefined when calling transactionLogGetTransactionLogByReferenceNumber.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (searchWord !== undefined && searchWord !== null) {
            queryParameters = queryParameters.set('searchWord', <any>searchWord);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<TransactionLogDto>(`${this.basePath}/api/TransactionLog/GetTransactionLogByReferenceNumber/${encodeURIComponent(String(referenceNumber))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param senderId
     * @param startIndex
     * @param count
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transactionLogGetTransactionLogBySenderId(senderId: string, startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<TransactionLog>>;
    public transactionLogGetTransactionLogBySenderId(senderId: string, startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TransactionLog>>>;
    public transactionLogGetTransactionLogBySenderId(senderId: string, startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TransactionLog>>>;
    public transactionLogGetTransactionLogBySenderId(senderId: string, startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (senderId === null || senderId === undefined) {
            throw new Error('Required parameter senderId was null or undefined when calling transactionLogGetTransactionLogBySenderId.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<TransactionLog>>(`${this.basePath}/api/TransactionLog/GetTransactionLogBySenderId/${encodeURIComponent(String(senderId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param serviceProviderId
     * @param from
     * @param to
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transactionLogMonthlyTransactionLog(serviceProviderId?: string, from?: Date, to?: Date, observe?: 'body', reportProgress?: boolean): Observable<Array<MonthlyTransactionLogModel>>;
    public transactionLogMonthlyTransactionLog(serviceProviderId?: string, from?: Date, to?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MonthlyTransactionLogModel>>>;
    public transactionLogMonthlyTransactionLog(serviceProviderId?: string, from?: Date, to?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MonthlyTransactionLogModel>>>;
    public transactionLogMonthlyTransactionLog(serviceProviderId?: string, from?: Date, to?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from.toISOString());
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to.toISOString());
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<MonthlyTransactionLogModel>>(`${this.basePath}/api/TransactionLog/monthlyreport`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param transactionLog
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transactionLogUpdateTransactionLog(transactionLog: TransactionLog, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public transactionLogUpdateTransactionLog(transactionLog: TransactionLog, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public transactionLogUpdateTransactionLog(transactionLog: TransactionLog, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public transactionLogUpdateTransactionLog(transactionLog: TransactionLog, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (transactionLog === null || transactionLog === undefined) {
            throw new Error('Required parameter transactionLog was null or undefined when calling transactionLogUpdateTransactionLog.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<boolean>(`${this.basePath}/api/TransactionLog/update`,
            transactionLog,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param serviceProviderId
     * @param from
     * @param to
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transactionLogWeeklyTransactionLog(serviceProviderId?: string, from?: Date, to?: Date, observe?: 'body', reportProgress?: boolean): Observable<Array<WeeklyTransactionLogModel>>;
    public transactionLogWeeklyTransactionLog(serviceProviderId?: string, from?: Date, to?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<WeeklyTransactionLogModel>>>;
    public transactionLogWeeklyTransactionLog(serviceProviderId?: string, from?: Date, to?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<WeeklyTransactionLogModel>>>;
    public transactionLogWeeklyTransactionLog(serviceProviderId?: string, from?: Date, to?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from.toISOString());
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to.toISOString());
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<WeeklyTransactionLogModel>>(`${this.basePath}/api/TransactionLog/weeklyreport`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param serviceProviderId
     * @param from
     * @param to
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transactionLogYearlyTransactionLog(serviceProviderId?: string, from?: Date, to?: Date, observe?: 'body', reportProgress?: boolean): Observable<Array<YearlyTransactionLogModel>>;
    public transactionLogYearlyTransactionLog(serviceProviderId?: string, from?: Date, to?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<YearlyTransactionLogModel>>>;
    public transactionLogYearlyTransactionLog(serviceProviderId?: string, from?: Date, to?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<YearlyTransactionLogModel>>>;
    public transactionLogYearlyTransactionLog(serviceProviderId?: string, from?: Date, to?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from.toISOString());
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to.toISOString());
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<YearlyTransactionLogModel>>(`${this.basePath}/api/TransactionLog/yearlyreport`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
